import {
  createEl, // args: tag, classes, textNode, attributes
} from '../../helpers/domHelpers';
import styles from '../../css/appointmentView.css';
import { widgetCtrl as ctrl } from '../../widgetController';

function createInputField(id, labelText, attr, error = '', tag = 'input') {
  const inputRow = createEl('div', styles.formInputRow);
  const label = createEl('label', styles.formLabel, labelText, { for: id });
  const input = createEl(tag, styles.formTextInput, '', Object.assign(attr, { id }));
  input.addEventListener('invalid', () => {
    input.setCustomValidity(error);
  });
  input.addEventListener('input', () => {
    input.setCustomValidity('');
    if (!input.checkValidity()) {
      input.setCustomValidity(error);
    }
  }, false);
  inputRow.append(label, input);
  return inputRow;
}

const phoneRegex = '^\\(?[2-9]{1}[\\d]{2}\\)?-?[2-9]{1}\\d{2}-?\\d{4}$';
var isValidZip = /(^\d{5}$)|(^\d{5}-\d{4}$)/;

const extraQuestions = {
  orthoconfirm: `
    <label class=${styles.radioLabel}>* Are you looking to get braces or invisalign?
        <select class=${styles.dropdown} required >
            <option />
            <option value="yes">Yes</label>
            <option value="no">No</label>
        </select>
      </label>
  `,
};

const form = {
  init() {
    const formAttributes = process.env.NODE_ENV === 'production' ?
      { id: 'openchair_widget-form' } :
      { id: 'openchair_widget-form', novalidate: true };
    this.form = createEl('form', styles.form, '', formAttributes);

    // create all the inputs
    const patientFirstName = createInputField('openchair-patient-first-name', '* First Name', { type: 'text', inputmode: 'latin-name', required: true, placeholder: 'First Name' }, 'This field is required');
    const patientLastName = createInputField('openchair-patient-last-name', '* Last Name', { type: 'text', inputmode: 'latin-name', required: true, placeholder: 'Last Name' }, 'This field is required');
    const parentName = createInputField('openchair-guardian-name', 'Guardian', { type: 'text', inputmode: 'latin-name', placeholder: 'First Name Last Name' });
    const emailAddress = createInputField('openchair-email', '* Email', { type: 'email', required: true, placeholder: 'email@example.com' }, 'Please input a valid email address');

    const phoneNumber = createInputField('openchair-phone', '* Phone', { type: 'tel', required: true, placeholder: '987-654-3210', pattern: phoneRegex }, 'Please input a valid phone number');
    const message = createInputField('openchair-message', 'Message', { maxlength: 1000, placeholder: 'How can we help you?' }, 'textarea');
    this.form.append(patientFirstName, patientLastName, parentName, emailAddress, phoneNumber, message);

    if (ctrl.cloud9Practice()) {
      const zipCode = createInputField('openchair-zip-code', '* Zip Code', { type: 'number', required: true, pattern: isValidZip, placehold: 'Zip Code' }, 'Please enter a valid zip code');
      this.form.append(zipCode);
    }

    if (ctrl.getExtraFormInfo()) {
      const extraQuestion = createEl('div', styles.formInputRow, '', { id: 'openchair-orthoconfirm' });
      extraQuestion.innerHTML = extraQuestions.orthoconfirm;
      this.form.append(extraQuestion);
    }

    return this.form;
  },

  render() {
    this.form.reset();
  },
};

export default form;



// WEBPACK FOOTER //
// ./src/views/appointmentView/form.js